import React from 'react';
import styled from 'styled-components';

const LinkToApp = styled.span.attrs({})`
  color: #4db2ec;
  margin: 0 3rem;
  text-transform: uppercase;
  font-family: Montserrat;
  font-size: 14.2px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 50px;
  letter-spacing: normal;
`;

const goToURL = url => {
  window.open(url, '_blank');
};

const appLink = () => {
  return (
    <LinkToApp
      className="AppLink pointer"
      onClick={() =>
        goToURL(
          'https://play.google.com/store/apps/details?id=com.beebom.app.beebom&utm_source=app.beebom.com&utm_medium=website&utm_campaign=landing'
        )
      }
    >
      App
    </LinkToApp>
  );
};

export default appLink;
